import React from "react";
import {
  HellenicEducationalRobotics,
  KPKIT,
  NAVTTC,
  PSEB,
  StartupGrind,
  TEVTA,
} from "../Icons";

const partners = [
  {
    id: 1,
    logo: HellenicEducationalRobotics,
    name: "Hellenic Educational Robotics Organization (Greece)",
    stripClass: "bg-[#707070]",
  },
  {
    id: 2,
    logo: StartupGrind,
    name: "Startup Grind USA ",
    stripClass: "bg-[#F5F5F5]",
  },
  {
    id: 3,
    logo: TEVTA,
    name: "TEVTA",
    stripClass: "bg-[#F5F5F5]",
  },
  {
    id: 4,
    logo: PSEB,
    name: "PSEB",
    stripClass: "bg-[#242626]",
  },
  {
    id: 5,
    logo: KPKIT,
    name: "KPKIT",
    stripClass: "bg-[#0D4C4A]",
  },
  {
    id: 6,
    logo: NAVTTC,
    name: "NAVTTC",
    stripClass: "bg-[#F1F1F1]",
  },
];

const StrategicPartnershipsSection = () => {
  return (
    <section className="bg-white px-4 pb-12 pt-10 sm:px-6 sm:pb-16 sm:pt-14 lg:px-8 lg:pb-[90px] lg:pt-[75px]">
      <div className="mx-auto max-w-[1720px]">
        <div className="mx-auto max-w-[1056px] text-center text-black">
          <p className="text-base font-bold leading-6 sm:text-lg sm:leading-[23px] lg:text-xl">
            Global Network
          </p>
          <h2 className="mt-3 text-[28px] font-bold leading-tight sm:mt-4 sm:text-[32px] sm:leading-[38px] lg:text-[40px] lg:leading-[47px]">
            Strategic Partnerships
          </h2>
          <p className="mt-4 text-base leading-6 sm:mt-5 sm:text-lg sm:leading-[23px] lg:text-xl">
            We collaborate with leading international and national organizations
            to expand our reach and enhance our educational impact across
            diverse markets and communities.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 min-[480px]:grid-cols-2 sm:mt-16 md:grid-cols-3 md:gap-7 lg:mt-20 xl:grid-cols-6">
          {partners.map((partner) => (
            <article
              key={partner.id}
              className="overflow-hidden bg-white shadow-[0_12px_10.5px_-3px_#00000075]"
            >
              <div
                className={`flex h-20 items-center justify-center px-4 sm:h-[98px] sm:px-5 ${partner.stripClass}`}
              >
                <partner.logo />
              </div>
              <div className="flex min-h-[120px] items-center justify-center px-4 py-6 text-center sm:min-h-[159px] sm:px-5 sm:py-8">
                <p className="text-base font-bold leading-6 text-black sm:text-lg sm:leading-[23px] lg:text-xl">
                  {partner.name}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StrategicPartnershipsSection;
